import { financeAPI } from "../../axios";

export const actions = {
    GetMySavings(context, data){
        return financeAPI.get(`Saving/My/${data.cycle}/${data.deliveryUnitId}`);
    },
    GetSavingsByDU(context, data){
        return financeAPI.get(`Saving/DeliveryUnit/${data.id}/${data.cycle}`);
    },
    AddSavings(context, data){
        return financeAPI.post(`Saving/Add`, data);
    },
    GetSavingDetails(context, data){
        return financeAPI.get(`Saving/Details/${data.id}/${data.cycle}/${data.deliveryUnitId}`);
    },
}